const all_modules = Object.freeze([
  {
    id: 1,
    module: "Client Management",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 2,
    module: "Task Management",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 32,
    module: "Archived Tasks ",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    id: 3,
    module: "Email Templates",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 4,
    module: "Employee Master",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
    locatedAt: "Masters > ",
  },
  {
    id: 5,
    module: "Practice Master",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
    locatedAt: "Masters > ",
  },
  {
    id: 6,
    module: "Service Master",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: false,
    locatedAt: "Masters > ",
  },
  {
    id: 31,
    module: "Service Tag Master",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
    locatedAt: "Masters > ",
  },
  // {
  //     id: 7,
  //     module: "Address Type Master",
  //     view: 0,
  //     add: 0,
  //     edit: 0,
  //     delete: 0,
  //     isAdd: true,
  //     isEdit: true,
  //     isDelete: true
  // },
  {
    id: 8,
    module: "Client Status",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: false,
    locatedAt: "Masters > Workflow > ",
  },
  {
    id: 9,
    module: "Status Master",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: false,
    locatedAt: "Masters > Workflow > ",
  },
  {
    id: 10,
    module: "Work Type",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: false,
    locatedAt: "Masters > Workflow > ",
  },
  // {
  //     id: 11,
  //     module: "VAT Period",
  //     view: 0,
  //     add: 0,
  //     edit: 0,
  //     delete: 0,
  //     isAdd: true,
  //     isEdit: true,
  //     isDelete: true
  // },
  {
    id: 12,
    module: "Payroll Frequency",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: true,
    isDelete: false,
    locatedAt: "Masters > Deadline > ",
  },
  // {
  //     id: 13,
  //     module: "Management Account Frequency",
  //     view: 0,
  //     add: 0,
  //     edit: 0,
  //     delete: 0,
  //     isAdd: true,
  //     isEdit: true,
  //     isDelete: true
  // },
  // {
  //   id: 14,
  //   module: "Client Type",
  //   view: 0,
  //   add: 0,
  //   edit: 0,
  //   delete: 0,
  //   isAdd: true,
  //   isEdit: true,
  //   isDelete: false,
  //   locatedAt: "Masters > Client Info > ",
  // },
  {
    id: 15,
    module: "Bookkeeper",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: false,
    locatedAt: "Masters > Client Info > ",
  },
  {
    id: 16,
    module: "Bookkeeping System",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: false,
    locatedAt: "Masters > Client Info > ",
  },
  {
    id: 17,
    module: "Prefix Master",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: false,
    locatedAt: "Masters > Client Info > ",
  },
  {
    id: 18,
    module: "Document Master",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: false,
    locatedAt: "Masters > Client Info > ",
  },
  {
    id: 19,
    module: "Invoicing Method",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: false,
    locatedAt: "Masters > Finance > ",
  },
  {
    id: 20,
    module: "Payment Method",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: false,
    locatedAt: "Masters > Finance > ",
  },
  {
    id: 21,
    module: "Connected Client",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: false,
    locatedAt: "Masters > Reference > ",
  },
  {
    id: 22,
    module: "Roles & Permission",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 30,
    module: "MOM",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 23,
    module: "Invoices",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    id: 24,
    module: "Time Sheets",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
    locatedAt: "Reports > ",
  },
  {
    id: 26,
    module: "Gocardless Report",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: false,
    isDelete: false,
    locatedAt: "Reports > ",
  },
  {
    id: 27,
    module: "Email Logs",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: false,
    isDelete: false,
    locatedAt: "Reports > ",
  },
  {
    id: 25,
    module: "Audit Logs",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: false,
    isDelete: false,
    locatedAt: "Reports > ",
  },
  {
    id: 28,
    module: "Employee Designation ",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: false,
    isDelete: false,
    locatedAt: "Reports > ",
  },
  {
    id: 29,
    module: "Budget Master",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: false,
    locatedAt: "Masters > ",
  },
  {
    id: 33,
    module: "Email Manager",
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
])

export default all_modules
